import { connect } from 'react-redux';
import MobileWelcome from '../components/MobileWelcome.jsx';
import { acknowledgeMobileWelcome } from '../actions/ui.js';
import { getCurrentDeck, getCurrentInvite, getInviteeCount} from '../selectors';

const mapStateToProps = (state, ownProps) => ({
  deck: getCurrentDeck(state, ownProps),
  invite: getCurrentInvite(state, ownProps),
  inviteeCount: getInviteeCount(state, ownProps),
});

const mapDispatchToProps = {
  acknowledgeMobileWelcome
};

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(MobileWelcome);
